export const AI_LLM_RAG_USER_ID = "019d00fc-b343-7f63-9392-995719e3a5d2";
export const MAX_TICKET_TITLE_LENGTH = 254;
